import Exception from './Exception'

export default class UnsupportedOperationException extends Exception { }
